export interface RouteCapabilityRule {
  pathPrefix: string;
  capability: string;
}

export const ROUTE_CAPABILITY_RULES: RouteCapabilityRule[] = [
  { pathPrefix: "/admin", capability: "capability:admin_console" },
  { pathPrefix: "/staff", capability: "capability:ops_dashboard" },
  { pathPrefix: "/dashboard", capability: "capability:customer_portal" },
  { pathPrefix: "/products", capability: "capability:catalog_access" },
  { pathPrefix: "/farms", capability: "capability:catalog_access" },
  { pathPrefix: "/orders", capability: "capability:ops_dashboard" },
  { pathPrefix: "/messages", capability: "capability:authenticated" },
  { pathPrefix: "/notifications", capability: "capability:authenticated" },
  { pathPrefix: "/settings", capability: "capability:authenticated" },
  { pathPrefix: "/profile", capability: "capability:authenticated" },
  { pathPrefix: "/onboarding", capability: "capability:ops_dashboard" },
];

export const requiredCapabilityForPath = (pathname: string): string | null => {
  for (const rule of ROUTE_CAPABILITY_RULES) {
    if (pathname === rule.pathPrefix || pathname.startsWith(`${rule.pathPrefix}/`)) {
      return rule.capability;
    }
  }
  return null;
};
